// "From Vavr" (notification center, owner decision 2026-10-17): an announcement Vavr sent to this
// person shows as a card until they close it (which marks it read). Push and email carry it too.
import { SupportAccess } from "./ViewAccess.tsx";
import { useState } from "react";
import { Banner, Button } from "@vavr/ui";
import { api, useAsync } from "../shared/index.ts";

interface News { id: string; title: string; body: string; created_at: number; read_at: number | null }

export function VavrNews() {
  const q = useAsync(() => api<{ announcements: News[] }>("GET", "/api/v1/me/announcements").catch(() => ({ announcements: [] })), []);
  const [gone, setGone] = useState<string[]>([]);
  const shown = (q.data?.announcements ?? []).filter((n) => !n.read_at && !gone.includes(n.id)).slice(0, 2);
  return (
    <div className="pmu-stack">
      <SupportAccess />
      {shown.map((n) => (
        <Banner key={n.id} tone="info" title={`From Vavr: ${n.title}`}>
          <p className="pmu-support-msg__body">{n.body}</p>
          <Button size="sm" variant="ghost" onClick={() => { setGone((g) => [...g, n.id]); void api("POST", `/api/v1/me/announcements/${n.id}/read`).catch(() => undefined); }}>Got it</Button>
        </Banner>
      ))}
    </div>
  );
}
